module.exports = __webpack_public_path__ + "static/img/devolver.a17b180a.png";